/**
 * @generated SignedSource<<706329c05741c155d76dd768e4dad5b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteRoleInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteRoleMutation$variables = {
  input: DeleteRoleInput;
};
export type deleteRoleMutation$data = {
  readonly deleteRole: {
    readonly deletedRoleId: string | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type deleteRoleMutation = {
  variables: deleteRoleMutation$variables;
  response: deleteRoleMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteRolePayload",
    "kind": "LinkedField",
    "name": "deleteRole",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedRoleId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteRoleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteRoleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c251d98825a7f9a0fd19bee5de3f82dd",
    "id": null,
    "metadata": {},
    "name": "deleteRoleMutation",
    "operationKind": "mutation",
    "text": "mutation deleteRoleMutation(\n  $input: DeleteRoleInput!\n) {\n  deleteRole(input: $input) {\n    deletedRoleId\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "512aeaf8a5f2f9d8b758a578e043538e";

export default node;
